import React from 'react';

import { useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import usePublisher from 'api/usePublisher';
import { useUserDetails } from 'api/useUserDetails';

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from 'components/ui';

import ProfileDropDown from './ProfileDropDown/ProfileDropDown';

export const Header: React.FC = () => {
  const { publisherId } = useParams();
  const { userDetails } = useUserDetails();
  const { getPublisher } = usePublisher(publisherId);

  const domain = getPublisher.data?.domain;
  const domainUrl = domain?.startsWith('http') ? domain : `https://${domain}`;

  const handleOpenDomain = () => {
    window.open(domainUrl, '_blank');
  };

  return (
    <header className="sticky top-0 z-50 mx-7 mt-2.5 mb-4 flex shrink-0 items-center bg-white">
      <Breadcrumbs />
      <div className="flex-1 flex justify-end items-center gap-x-2">
        {domain && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  onClick={handleOpenDomain}
                  className="group flex items-center justify-center w-10 h-10 rounded-md border border-transparent hover:border-base-border hover:shadow-md transition-all"
                >
                  <FontAwesomeIcon
                    icon="fa-solid fa-arrow-up-right"
                    className="text-neutral-600 text-base group-hover:text-indigo-600 transition-colors"
                  />
                </button>
              </TooltipTrigger>
              <TooltipContent
                side="bottom"
                align="center"
                className="rounded-md border border-base-popover bg-base-popover shadow-md py-[6px] px-[12px]"
              >
                <span className="text-p-s text-base-mutedForeground">
                  {domainUrl}
                </span>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
        <ProfileDropDown user={userDetails} />
      </div>
    </header>
  );
};
